import { render, staticRenderFns } from "./backDetail.vue?vue&type=template&id=5ab00462&scoped=true"
import script from "./backDetail.vue?vue&type=script&lang=js"
export * from "./backDetail.vue?vue&type=script&lang=js"
import style0 from "./backDetail.vue?vue&type=style&index=0&id=5ab00462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00462",
  null
  
)

export default component.exports